import Animate from './modules/Animate';

function init() {
  document.querySelectorAll('[data-appear-animation]').forEach(item => {
    if (item instanceof HTMLElement) {
      const optionsString = item.getAttribute('data-plugin-options');

      let options = {};
      if (optionsString) {
        try {
          options = JSON.parse(optionsString.replace(/'/g, '"'));
        } catch (e) {
          options = {};
        }
      }
      new Animate(item, options);
    }
  });
}

window.addEventListener('load', init, false);
